// extracted by mini-css-extract-plugin
export default {"clear":"reset_clear_y5zm7","clearfix":"reset_clearfix_nKlFM"};